
export default function nav() {

  $('#header .nav-container a, .menu-contact').on('click', function(e) {
    e.preventDefault();
    
		if (this.hash !== "") {
      // Store hash
      var hash = this.hash;
      var pos = $(hash).offset().top;

      if ( is_desktop() ) {
        pos -= 98;
      }

      $('html, body').animate({
        scrollTop: pos
      }, 800, function(){
        $( '#header .hamburger' ).removeClass( 'is-active' );
		    $( '.header-container' ).removeClass( 'active' );
      });
    }
  });
  
  $('#header .hamburger').on('click', function (e) {
		e.preventDefault();
		$( this ).toggleClass( 'is-active' );
		$( '.header-container' ).toggleClass( 'active' );
  });

  styleHeader();
  
  $(window).on('scroll', function() {
    styleHeader();
  });

  function styleHeader() {
    var pos = $(document).scrollTop();

    if ( is_desktop() ) {
      if ( pos > 100 ) {
        $('#header').addClass('header-black');
      } else {
        $('#header').removeClass('header-black');
      }
    }
  }

  function is_desktop() {
    return $(window).width() > 992;
  }
}